export default "__VITE_ASSET__DcaSYsJ2__"